/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Activity/view.blocks to change it.
import * as fromData from 'Simple/Data'
import ActivityType from './ActivityType/index'
import LineWithDot from './LineWithDot/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Activity({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity"
  
}) {
let activityItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'activity_item',
path: 'isFirst',
})
let activityItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'activity_item',
path: 'isLast',
})
  return (<React.Fragment
>
<div
  data-testid="Activity.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<LineWithDot
  viewPath={`${viewPath}/LineWithDot`}
 data="activity_item.isFirst"
 isFirst={activityItemIsFirstValueData}
 data="activity_item.isLast"
 isLast={activityItemIsLastValueData}
/>
<div
  data-testid="Activity.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ActivityType
  viewPath={`${viewPath}/ActivityType`}
/>
</div>
</div>
{children}
</React.Fragment>)
}